import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { useMount } from '@perpay-web/hooks/useMount';

import styles from './CardStandardRejection.scss';

const CardStandardRejection = ({ onClickDashboard, onMount, isPho }) => {
    useMount(onMount);
    const isPhoQuery = isPho ? '?PHO_complete=true' : '';

    return (
        <div className={styles.wrapper}>
            <LegacyFocusLayout
                className={styles.container}
                contentClassName={styles.content}
                footer={
                    <div className={styles.footer}>
                        <CardCta
                            mode='dark'
                            Component={CustomLink}
                            href={`${paths.dashboard.path}${isPhoQuery}`}
                            onClick={() => onClickDashboard()}
                            className={styles.footer__button}
                        >
                            View dashboard
                        </CardCta>
                    </div>
                }
            >
                <div className={styles.heading}>
                    <ResponsiveHeader className={styles.header}>
                        Your card application was not approved
                    </ResponsiveHeader>
                    <ResponsiveCopy className={styles.copy}>
                        Please check your email for more information on this
                        decision. This decision will not impact your credit
                        score.
                    </ResponsiveCopy>
                </div>
                <div className={styles.list__name}>What&apos;s next?</div>
                <div className={styles.card}>
                    <Stack className={styles.stack}>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon_grafik} />
                            Access your dashboard and discover ways to improve
                            your chances of approval.
                        </div>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon_date} />
                            From your dashboard, you can reapply for the Perpay
                            Credit Card in{' '}
                            <span className={styles.highlight}>30 days.</span>
                        </div>
                    </Stack>
                </div>
            </LegacyFocusLayout>
        </div>
    );
};

export default CardStandardRejection;
